import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import '../index.less'
import FindleModal from './components/FindleModal.vue'

@Component({
  components: {
    FindleModal
  }
})
export default class RulesViews extends Vue {
  @Prop({ default: () => []}) readonly data: Array<any>
  @Prop({ default: ""}) readonly code: String

  @Watch("data", { immediate: true })
  handleget(){
    this.dataSource = []
    this.dataSource = JSON.parse(JSON.stringify(this.data))
    this.count = this.data.length + 1
  }

  updated(){
    const div = document.querySelector('#rulesViews-table')
    if(div !== null){
      this.cilentHeight = div.clientHeight - 110
    }
  };

  onSortBlur(e: any, key: string) {
    const value = Number(e.target.value)
    // 找到当前改变的是哪条数据
    const index = this.dataSource.findIndex(res => res.id === key)
    // 现在要把这条数据
    const delArr = this.dataSource.splice(index, 1)
    this.dataSource.splice(value - 1, 0, delArr[0])
    this.dataSource.forEach((res, index) => {
      res.sort = index + 1
    })
    this.$emit('addSave',this.dataSource)
  }

  handleInputChange(value: any, key: string) {
    // console.log('输入框：', value, key, column)
    const newData = [...this.dataSource]
    const target = newData.find(item => key === item.id)
    if (target) {
      target['sort'] = value
    }
    this.dataSource = newData
  }
  filterOption(input, option) {
    return (
      option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    );
  }

  get columns() {
    return [
      {
        title: this.$t('page_resource_pool_no'),
        dataIndex: 'sort',
        key: 'sort',
        width:120,
        customRender: (sort, record, index) => {
          return (
            <a-input-number min={1} value={sort} style="width: 80px"
              onBlur={e => this.onSortBlur(e, record.id)}
              onChange={e => this.handleInputChange(e, record.id)}
            />
          )
        },
      },
      {
        title: this.$t('actions'),
        dataIndex: 'actions',
        key: 'actions',
        width:150,
        ellipsis: true,
        customRender: (_,record) => {
          return (
            <div style="">
              <a
                type="link"
                v-acl="page_system_coding_rules_name_edit"
                disabled={record.type === ""}
                onClick={(e) => {
                  e.stopPropagation();
                  this.openEdit(record);
                }}
              >
                {this.$t('page_rules_set_rules')}
              </a>
              <a-divider type="vertical" />
              <a
                type="link"
                v-acl="page_system_coding_rules_name_delete"
                style="color: #fa554c"
                onClick={(e) => {
                  e.stopPropagation();
                  this.delete(record.sort);
                }}
              >
                {this.$t("delete")}
              </a>
            </div>
          );
        },
      },
      {
        title: this.$t('page_bill_manage_title'),
        dataIndex: 'name',
        key: 'name',
        width:150,
        ellipsis: true,
        customRender: (row,record) => {
          return (
            <a-input
              value={row}
              onChange={e => this.handleChange(e.target.value, record.sort, 'name')}
              placeholder={this.$t('page_bill_manage_title')}
            />
          );
        },
      },
      {
        title: this.$t('page_bill_manage_type'),
        dataIndex: 'type',
        key: 'type',
        width:150,
        ellipsis: true,
        customRender: (row,record) => {
          return (
            <a-select
              style="width:100%"
              value={row}
              showSearch = {true}
              filterOption = {this.filterOption}
              onChange={e => this.handleChange(e, record.sort, 'type')}
              placeholder={this.$t('page_system_coding_rules_application_object')}
            >
              {this.typeList.map(res =>{ return<a-select-option value={res.key}>
                { res.value }
              </a-select-option>})}
            </a-select>
          );
        },
      },
      {
        title: this.$t('remark'),
        dataIndex: 'remark',
        key: 'remark',
        ellipsis: true,
        customRender: (row,record) => {
          return (
            <a-input
              value={row}
              onChange={e => this.handleChange(e.target.value, record.sort, 'remark')}
              placeholder={this.$t('remark')}
            />
          );
        },
      },
    ]
  };
  loading = false
  scroll = {}
  selectedRowKeys = []
  selectedIds = []
  selectedRows = []
  editdata: any = {};
  selectRowKey = ""
  count = 1
  dataSource = []
  typeList = [
    {
      key: 1,
      value: '文本'
    },
    {
      key: 2,
      value: '日期'
    },
    {
      key: 3,
      value: '时间'
    },
    {
      key: 4,
      value: '流水号'
    }
  ]
  editVisible = false
  editItme:any = {}
  cilentHeight = 130

  delete(key){
    const dataSource = [...this.dataSource];
    this.dataSource = dataSource.filter(item => item.sort !== key);
    this.$emit('addSave',this.dataSource)
  }

  openEdit(value){
    this.editItme = value
    this.editVisible = true
  }

  handleChange(value, key, column) {
    const newData = [...this.dataSource];
    const target = newData.filter(item => key === item.sort)[0];
    if (target) {
      target[column] = value;
      this.dataSource = newData;
    }
    this.$emit('addSave',this.dataSource)
  }

  save(value){
    const newData = [...this.dataSource];
    let target = newData.filter(item => this.editItme.sort === item.sort)[0];
    if (target) {
      Object.keys(value).forEach(key =>{
        target[key] = value[key]
      })
      this.dataSource = newData;
    }
    this.editVisible = false
    this.$emit('addSave',this.dataSource)
  }

  handleAdd() {
    const { count, dataSource } = this;
    const newData = {
      sort: count,
      name: "",
      type: "",
      remark: ""
    };
    this.dataSource = [...dataSource, newData];
    this.count = count + 1;
  }

  render(){
    return(
      <div>
        <ml-table
          rowKey="id"
          defaultExpandAllRows={true}
          canChangeColWidth={true}
          loading={this.loading}
          bordered
          dataSource={this.dataSource}
          columns={this.columns}
          scroll={{y: this.cilentHeight}}
        >
        </ml-table>
        <a-button type="primary" style="width:100%;margin-top:8px;" onClick={() => this.handleAdd()}><a-icon type="plus" />{this.$t('page_getwat_list_new_attribute')}</a-button>
        <findle-modal
          item={this.editItme}
          code={this.code}
          visible={this.editVisible}
          onCancel={() => this.editVisible = false}
          onSave={value => this.save(value)}
        ></findle-modal>
      </div>
    )
  }
}
